import { useState } from "react";

import MDBox from "shared/components/MDBox";

import FileList from "./file_list";
import FileCreate from "./file_create";

function getStepContent(stepIndex, setFileStep) {
  switch (stepIndex) {
    case "list":
      return <FileList setFileStep={setFileStep} />;

    case "create":
      return <FileCreate setFileStep={setFileStep} />;

    default:
      return null;
  }
}

function Files() {
  const [fileStep, setFileStep] = useState("list");

  return <MDBox pb={1}>{getStepContent(fileStep, setFileStep)}</MDBox>;
}

export default Files;
